export default "__VITE_ASSET__OXVXESLU__"